import React from 'react';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const buttonStyles = {
    padding: { xs: '18px 0px 18px 0px', sm: '24px 0px 24px 0px' },
    background: {
        xs: '#ffffff',
        sm: '#ffffff',
    },
    border: '1px solid rgb(231, 35, 5)',
    borderRadius: 0,
    boxShadow: 'none',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'rgb(231, 35, 5)',
    fontSize: { xs: '18px', sm: '20px' },
    lineHeight: { xs: '18px', sm: '20px' },
    fontWeight: 500,
    letterSpacing: '.5px',
    textTransform: 'uppercase',
    cursor: 'pointer',
    transition: 'background-color 0.3s, border-color 0.3s, color 0.3s',

    "&:hover": {
        backgroundColor: 'rgb(44, 42, 41)',
        color: 'rgb(255, 255, 255)',
        boxShadow: 'none',
        border: '1px solid rgb(44, 42, 41)',
    },

    "& .MuiButton-endIcon": {
        position: 'unset',
        marginLeft: '16px',  // Spacing between text and icon
        marginRight: 0,
        transition: 'none',  // No transition for the icon
        color: 'rgb(231, 35, 5)',  // Make sure the icon color inherits from the button's color
    },

    "&.Mui-disabled": {
        borderColor: 'transparent',
        cursor: 'not-allowed',

        "& .MuiButton-endIcon": {
            color: 'inherit',
        },
    }
};

const StyledButton = ({ children, onClick, endIcon, ...otherProps }) => (
    <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={onClick}
        endIcon={endIcon ? endIcon : <ArrowForwardIcon />}
        sx={buttonStyles}
        {...otherProps}
    >
        {children}
    </Button>
);

export default StyledButton;
